/** @format */

'use strict';
// Generated by jhipster/controller/genericOverviewWithPaging.ftl

angular
	.module('emsApp')
	.controller('CarRentalTypeController', function(
		$scope,
		$rootScope,
		$state,
		$stateParams,
		$q,
		AlertService,
		CarRentalTypeFactory,
		FindAllCarRentalTypesByQueryParamsNonPageableFactory,
		NoPagingCarRentalTypeFactory
	) {
		$scope.carRentalTypeList = [];
		$scope.predicate = 'id';
		$scope.ascending = false;
		// a custom hook could be implemented here to add additional fields: custom/jhipster/controller/overview/additional-fields.ftl

		$scope.goToNewState = function() {
			// this overview is NOT mapped, it is the main overview
			$state.go('carrentaltype.list.new');
		};

		$scope.goToEditState = function(carRentalType) {
			// this overview is NOT mapped, it is the main overview
			$state.go('carrentaltype.list.edit', { carRentalTypeId: carRentalType.id });
		};

		$scope.getCarRentalTypeList = function() {
			FindAllCarRentalTypesByQueryParamsNonPageableFactory.query(
				{
					sort: [$scope.predicate + ',' + ($scope.ascending ? 'asc' : 'desc')],
				},
				function(result, headers) {
					$scope.totalItems = headers('X-Total-Count');
					$scope.totalCountIsKnownAtTheMoment = true;
					$scope.carRentalTypeList = result;
				}
			);
		};
		$scope.loadAll = function() {
			$scope.getCarRentalTypeList();
		};

		$scope.loadPage = function() {
			$scope.loadAll();
		};

		$scope.singleDelete = function(id) {
			$scope.selectedCarRentalTypeId = id;
			$('#deleteCarRentalTypeConfirmation').modal('show');
		};

		$scope.confirmSingleDelete = function() {
			CarRentalTypeFactory.delete(
				{ id: $scope.selectedCarRentalTypeId },
				function() {
					$scope.loadAll();
					$('#deleteCarRentalTypeConfirmation').modal('hide');
				},
				function(error) {
					$('#deleteCarRentalTypeConfirmation').modal('hide');
					AlertService.error(error.data.message, error.data.params);
				}
			);
		};

		$scope.loadPage();

		$scope.getSortIcon = function(itemName) {
			if ($scope.predicate === itemName) {
				if ($scope.ascending) {
					return 'glyphicon-sort-by-attributes';
				} else {
					return 'glyphicon-sort-by-attributes-alt';
				}
			} else {
				return 'glyphicon-sort';
			}
		};
	});
